<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Integração Zoppy</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Gerencie a configuração da integração com a Zoppy e acompanhe os logs de sincronização.
        </p>
      </div>
    </div>

    @if (isLoading) {
    <div class="section-container">
      <app-loading-box height="30" width="250" marginTop="0"></app-loading-box>
      <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      <div class="row mt-3">
        <div class="col-12 col-md-6">
          <app-loading-box height="56" width="100%"></app-loading-box>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <app-loading-box height="40" width="100%"></app-loading-box>
        </div>
      </div>
    </div>
    <div class="section-container mt-4">
      <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
      <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      <app-loading-box height="200" width="100%" marginTop="12"></app-loading-box>
    </div>
    } @else {
    <form [formGroup]="form">
      <!-- Seção Como Funciona -->
      <div class="section-container mb-4">
        <div class="section-title">
          <mat-icon>help_outline</mat-icon>
          <span>Como funciona</span>
        </div>

        <div class="action-card-grid mt-3">
          <app-action-card
            icon="storage"
            title="Configure o Resulth Local Connect"
            description="Configuere o resulth local connect para a integração ter acesso ao banco de dados do Resulth.">
          </app-action-card>

          <app-action-card
            icon="vpn_key"
            title="Configuere a Token da zoppy"
            description="Copie a token de integração na sua conta zoppy e cole aqui nas configurações">
          </app-action-card>

          <app-action-card
            icon="cloud_upload"
            title="Os dados sobem automaticamente">
            Agora todos os dados de Cliente, Produto e Pedidos são sincronizados automaticamente para a zoppy.
            <a href="javascript:void(0)" class="saiba-mais-link" (click)="abrirModalSaibaMais()">Saiba mais</a>
          </app-action-card>
        </div>
      </div>

      <!-- Seção Configuração -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon>settings</mat-icon>
          <span>Configuração</span>
        </div>

        <div class="row">
          <div class="col-12 col-md-3">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo" color="primary"> Ativo </mat-slide-toggle>
          </div>

          <div class="col-12 col-md-4">
            <div class="toggle-content">
              <mat-slide-toggle class="app-toggle-compact" formControlName="isResulth" color="primary">
                Integrar com Resulth
              </mat-slide-toggle>
              <span class="info-text">Esta opção está sempre ativa e não
                pode ser alterada.</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Chave Zoppy</mat-label>
              <input matInput formControlName="chaveZoppy" placeholder="Insira a chave da Zoppy" />
              @if (form.get('chaveZoppy')?.hasError('required')) {
              <mat-error>Obrigatório.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Seção Logs -->
      <div class="section-container mt-4">
        <div class="section-title">
          <mat-icon>history</mat-icon>
          <span>Logs</span>
        </div>

        <div class="row mt-3">
          <div class="col-12 mb-3">
            <app-alert-card type="info" icon="sync">
              <span>Última sincronização: <strong>{{ formatDate(ultimaSincronizacao) }}</strong></span>
            </app-alert-card>
          </div>

          <div class="col-12 mb-3" [formGroup]="filterForm" class="search-area">
            <div class="row align-items-end">
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100 h-100 mb-0">
                  <mat-label>Período</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="dataInicial" placeholder="Início" />
                    <input matEndDate formControlName="dataFinal" placeholder="Fim" />
                  </mat-date-range-input>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100 h-100 mb-0">
                  <mat-label>Tipo de Log</mat-label>
                  <mat-select formControlName="idTipoLog">
                    <mat-option [value]="null">Todos</mat-option>
                    @for (tipo of tiposLog; track tipo.idTipoLog) {
                    <mat-option [value]="tipo.idTipoLog">{{ tipo.descricao }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4 mb-3">
                <button mat-stroked-button class="btn-secondary w-100" type="button" (click)="filtrarLogs()">
                  <mat-icon>search</mat-icon> Filtrar
                </button>
              </div>
            </div>
          </div>

          <div class="col-12">
            @if (allLogs.length > 0) {
            <div class="table-wrapper">
              <table mat-table [dataSource]="dataSource" class="log-table">
                <ng-container matColumnDef="idLog">
                  <th mat-header-cell *matHeaderCellDef class="col-id">ID</th>
                  <td mat-cell *matCellDef="let log" class="col-id">#{{ log.idLog }}</td>
                </ng-container>

                <ng-container matColumnDef="datetimeInclusion">
                  <th mat-header-cell *matHeaderCellDef class="col-datetime">Data/Hora</th>
                  <td mat-cell *matCellDef="let log" class="col-datetime">
                    {{ formatDate(log.datetimeInclusion) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="descricaoTipoLog">
                  <th mat-header-cell *matHeaderCellDef class="col-tipo">Tipo</th>
                  <td mat-cell *matCellDef="let log" class="col-tipo">
                    <span class="status-badge" [ngClass]="getBadgeClass(log.idTipoLog)">
                      {{ log.descricaoTipoLog }}
                    </span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="zoppyUrl">
                  <th mat-header-cell *matHeaderCellDef class="col-url">URL Zoppy</th>
                  <td mat-cell *matCellDef="let log" class="col-url col-truncate" [title]="log.zoppyUrl">
                    {{ log.zoppyUrl }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                  <td mat-cell *matCellDef="let log" class="text-center w-actions">
                    <button mat-icon-button (click)="abrirDetalhe(log)" aria-label="Ver detalhes">
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
            <div class="col-12 text-center ver-mais-pesquisa">
              <button mat-button [disabled]="ultimaPagina" (click)="proximaPagina()">
                @if (isLoadingLogs === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                } @else {
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
              </button>
            </div>
            } @else if (allLogs.length === 0 && !isLoading) {
            <app-empty-list [title]="'Nenhum log encontrado'"></app-empty-list>
            }
          </div>
        </div>
      </div>
    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
